module.exports = __webpack_public_path__ + "static/media/Safe-T10.8220f8ca.jpg";